import { Component, Input, AfterViewInit, ElementRef, Output, EventEmitter, ViewChildren, QueryList, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { gsap } from 'gsap';

import { Dimensions, Serie, Legend, LegendTooltipPosEnum } from '../../models';

@Component({
    selector: '[aaLegend]',
    templateUrl: './legend.component.html',
    styleUrls: [
        './legend.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LegendComponent implements AfterViewInit
{
    @Input() dimensions: Dimensions;
    @Input() series: Serie[];
    @Input() config: Legend;
    @Input() radius?: number = 4;
    private _legendItems: QueryList<ElementRef>;
    @ViewChildren('legendItem') set legendItems (value: QueryList<ElementRef>)
    {
        if (value)
        {
            this._legendItems = value;
            this.update();
        }
    }
    @ViewChild('legend') legendGroup: ElementRef;
    @Output() toggleSerieVisibility: EventEmitter<void> = new EventEmitter<void>();
    public transformLegend: string;
    public legendWidth: number = 100;
    public legendHeight: number = 100;
    public widths: number[] = [];
    public heights: number[] = [];
    public transformItem: string[] = [];
    private rect: SVGRectElement;
    private spaceWidth: number = 20;
    private spaceHeight: number = 25;
    private static duration: number = 0.5;

    constructor (private elementRef: ElementRef)
    {
    }

    ngAfterViewInit ()
    {
        this.update();
    }

    toggleVisibility (id: number)
    {
        this.series[id].isVisible = !this.series[id].isVisible;
        this.toggleSerieVisibility.emit();
    }

    private update ()
    {
        // const margin = this.dimensions.marginRight - this.legendWidth;

        this.transformLegend = 'translate(-75px, -20px)';

        this.rect = this.elementRef.nativeElement.querySelector('rect');
        this.radius = this.radius ? this.radius : 4;

        const l = this._legendItems.map((eleRef: ElementRef) =>
            eleRef.nativeElement
        );
        if (l.length > 0)
        {
            const dims: any = l
                .map(
                    (item: any) =>
                        item.getBBox()
                );
            this.widths = dims.map((d: any) =>
                d.width + this.spaceWidth
            );
            this.heights = dims.map((d: any) =>
                d.height + this.spaceHeight
            );
            switch (this.config.pos)
            {
                case LegendTooltipPosEnum.TOP:
                    this.computeTop();

                    break;
            }

            gsap.timeline()
                .to(this.legendGroup.nativeElement, { duration: LegendComponent.duration, css: { transform: this.transformLegend }, ease: 'none' }, 0);
            l.forEach((li: any, idx: number) =>
            {
                gsap.timeline()
                    .to(li, { duration: LegendComponent.duration, css: { transform: this.transformItem[idx] }, ease: 'none' }, 0);
            });
        }
    }

    private computeTop ():void
    {
        const itemPosX: number[] = this.widths.map(
            (
                (sum: number) =>
                    (value: number) =>
                        (sum += value)
            )(-1 * this.widths[0])
        );

        this.transformItem = itemPosX.map((posX: number) =>
            'translate(' + posX + 'px, 0px)'
        );

        this.legendHeight = Math.max(...this.heights);
    }

    private computeRight ():void
    {
        const itemPosY: number[] = this.heights.map(
            (
                (sum: number) =>
                    (value: number) =>
                        (sum += value)
            )(-1 * this.heights[0])
        );

        this.transformItem = itemPosY.map((posY: number) =>
            'translate( 0px,' + posY + 'px,)'
        );
        this.legendHeight = Math.max(...this.heights);
    }
}
